<div class="container">
    <ng-container [ngSwitch]="applicationStage">
        <div *ngSwitchCase="applicationStageEnum.START" class="start">
            <h1>Become a Listique Partner</h1>
            <p class="description">
                Listique is the last word in luxury suppliers, to the most
                discerning clients. This process will ask you a few questions to
                form your application, which will then be manually reviewed by
                our staff, who will let you know if you have been successfully
                permitted to list on the directory.
            </p>
            <app-button [config]="{
                    title: 'Start Application',
                    type: 'button'
                }" (click)="changeApplicationStage(applicationStageEnum.FORM)"></app-button>
            <div class="benefits">
                <h6>Benefits to partnership</h6>
                <div class="ticks">
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Personal Dashboard</span>
                    </div>
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Qualified Leads</span>
                    </div>
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Exclusive Partner Profile</span>
                    </div>
                </div>
            </div>
            <div class="card-container">
                <h5>A Listique Partner is...</h5>
                <div class="cards">
                    <div class="card">
                        <mat-icon svgIcon="tie"></mat-icon>
                        <h5>Profile</h5>
                        <p>
                            You will be the best in your field, and striving to
                            maintain that excellence, for every customer.
                        </p>
                    </div>
                    <div class="card">
                        <mat-icon svgIcon="briefcase"></mat-icon>
                        <h5>Established</h5>
                        <p>
                            This isn’t your first foray into the luxury space.
                            You’ve been here for years, and have a wealth of
                            knowledge under your belt.
                        </p>
                    </div>
                    <div class="card">
                        <mat-icon svgIcon="partner-scales"></mat-icon>
                        <h5>Consistent</h5>
                        <p>
                            You treat every job like royalty, whether it’s the
                            lowest value of the day, or the highest. Quality is
                            not a compromise here.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngSwitchCase="applicationStageEnum.FORM" class="form">
            <div class="form-step-breadcrumb-bar">
                <ul>
                    <li *ngFor="let step of formSteps" [class.active]="step.active" [class.completed]="step.completed"
                        [class.progress]="step.progress">
                        {{ step.title }}
                    </li>
                </ul>
            </div>
            <form [formGroup]="applicationForm">
                <ng-container [ngSwitch]="applicationFormStage">
                    <ng-container *ngSwitchCase="applicationFormStageEnum.BUSINESS">
                        <h1>What is the name of your business?</h1>
                        <div class="inputs">
                            <input type="text" placeholder="Business Name" required formControlName="businessName" />
                            <span class="hint uppercase">
                                If you're a sole trader, you can put your name
                                here
                            </span>
                            <app-button [config]="{
                                    title: 'Next',
                                    type: 'button',
                                    fill: 'solidOutline',
                                    background: 'white',
                                    disabled: !applicationForm.controls[
                                        'businessName'
                                    ].valid
                                }" (click)="
                                    changeApplicationFormStage(
                                        applicationFormStageEnum.SECTOR,
                                        false,
                                        applicationForm.controls['businessName']
                                    )
                                "></app-button>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="applicationFormStageEnum.SECTOR">
                        <h1>What does your business do?</h1>
                        <div class="inputs">
                            <input type="text" placeholder="Nature of business" required
                                formControlName="businessDescription" />
                            <app-button [config]="{
                                    title: 'Next',
                                    type: 'button',
                                    fill: 'solidOutline',
                                    background: 'white',
                                    disabled: !applicationForm.controls[
                                        'businessDescription'
                                    ].valid
                                }" (click)="
                                    changeApplicationFormStage(
                                        applicationFormStageEnum.CONTACT,
                                        false,
                                        applicationForm.controls[
                                            'businessDescription'
                                        ]
                                    )
                                "></app-button>
                            <span class="hint">
                                If you would like to send samples, press books
                                or images, these can be sent to Adam Irving,
                                Listique, 2A Ledbury Mews North, London, W11
                                2AF. Please do not send high value items unless
                                covered by your own insurance. Please note that
                                we cannot be responsible for sending items back,
                                you will need to arrange your own courier for
                                collection.
                            </span>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="applicationFormStageEnum.CONTACT">
                        <h1>We’ll need an email to contact you...</h1>
                        <div class="inputs">
                            <input type="text" placeholder="Name" required formControlName="contactName" />
                            <input type="tel" placeholder="Contact Phone Number" required
                                formControlName="contactPhoneNumber" />
                            <input type="email" placeholder="Contact Email" required
                                formControlName="contactEmailAddress" />
                            <span class="hint uppercase">
                                This is to let you know the outcome of your
                                application.
                            </span>
                            <app-button [config]="{
                                    title: 'Next',
                                    type: 'button',
                                    fill: 'solidOutline',
                                    background: 'white',
                                    disabled: !applicationForm.controls[
                                        'contactEmailAddress'
                                    ].valid
                                }" (click)="
                                    changeApplicationFormStage(
                                        applicationFormStageEnum.CONTACT,
                                        true,
                                        applicationForm.controls[
                                            'contactEmailAddress'
                                        ]
                                    )
                                "></app-button>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="
                            applicationFormStageEnum.CONTACT_SECONDARY
                        ">
                        <h1>...and your business website.</h1>
                        <div class="inputs">
                            <input type="text" placeholder="Business Website" required formControlName="websiteUrl" />
                            <span class="hint uppercase">
                                THIS IS TO HELP US REVIEW YOUR APPLICATION. YOU
                                CAN PUT A SOCIAL MEDIA ACCOUNT IF YOU DON’T HAVE
                                A WEBSITE
                            </span>
                            <app-button [config]="{
                                    title: 'Next',
                                    type: 'button',
                                    fill: 'solidOutline',
                                    background: 'white',
                                    disabled: !applicationForm.controls[
                                        'websiteUrl'
                                    ].valid
                                }" (click)="
                                    changeApplicationFormStage(
                                        applicationFormStageEnum.PACKAGE,
                                        true,
                                        applicationForm.controls['websiteUrl']
                                    )
                                "></app-button>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="applicationFormStageEnum.PACKAGE">
                        <h1 style="margin-bottom: 0px;">Lastly...</h1>
                        <div class="inputs">
                            <p style="text-align: center; font-size: 27px;">
                                Which package would you like to signup to
                            </p>
                        </div>
                        <div class="partnership-fee">
                            <!--<div
                                class="card"
                                [class.active]="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value === 'standard'
                                "
                                (click)="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value = 'standard'
                                "
                            >
                                <div class="title">
                                    Standard Partnership
                                    <span>(Invoiced Annually)</span>
                                </div>
                                <div class="fee">
                                    £800
                                </div>
                            </div>-->
                            <!-- <div class="card" [class.active]="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value === 'deluxe'
                                " (click)="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value = 'deluxe'
                                ">
                                <div class="title">
                                    Deluxe
                                    <span>(Invoiced Annually)</span>
                                </div>
                                <div class="fee">
                                    £700
                                </div>
                            </div>
                            <div class="card" [class.active]="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value === 'presidential'
                                " (click)="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value = 'presidential'
                                ">
                                <div class="title">
                                    Presidential
                                    <span>(Invoiced Annually)</span>
                                </div>
                                <div class="fee">
                                    £1,000
                                </div>
                            </div> -->
                            <div class="card" [class.active]="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value === 'unsure'
                                " (click)="
                                    applicationForm.controls[
                                        'partnershipOption'
                                    ].value = 'unsure'
                                ">
                                <div class="title">
                                    Commission
                                    <span></span>
                                </div>
                                <div class="fee"></div>
                            </div>
                        </div>
                        <div class="inputs">
                            <app-button [config]="{
                                    title: 'Review',
                                    type: 'button',
                                    fill: 'solidOutline',
                                    background: 'white',
                                    disabled: !applicationForm.controls[
                                        'partnershipOption'
                                    ].valid
                                }" (click)="
                                    changeApplicationFormStage(
                                        applicationFormStageEnum.SUBMISSION,
                                        true
                                    )
                                "></app-button>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="applicationFormStageEnum.SUBMISSION">
                        <h1 style="margin-bottom: 0px;">Review and Submit</h1>
                        <div class="form-error" *ngIf="applicationFormError">
                            {{ applicationFormError }}
                        </div>
                        <div class="inputs">
                            <p style="text-align: center; font-size: 27px;">
                                Make sure the information below is correct. We
                                will review your application and make a decision
                                within a week.<br />
                                We will email you with the outcome of our
                                decision.
                            </p>
                            <br /><br />
                            <label>Business name</label>
                            <input type="text" formControlName="businessName" />
                            <label>Business description</label>
                            <input type="text" formControlName="businessDescription" />
                            <label>Name</label>
                            <input type="text" formControlName="contactName" />
                            <label>Contact Phone Number</label>
                            <input type="tel" formControlName="contactPhoneNumber" />
                            <label>Contact Email</label>
                            <input type="email" formControlName="contactEmailAddress" />
                            <label>Business website</label>
                            <input type="text" formControlName="websiteUrl" />
                            <re-captcha formControlName="recaptchaKey" size="invisible" #invisibleRecaptcha (resolved)="
                                    this.applicationForm
                                        .get('recaptchaKey')
                                        .setValue($event);
                                    recaptchaSuccess()
                                "></re-captcha>
                            <app-button [config]="{
                                    title: 'Submit Application',
                                    type: 'button',
                                    disabled:
                                        !applicationForm.valid ||
                                        applicationFormSending
                                }" (click)="submitApplication()"></app-button>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
            <div class="card-container wide" *ngIf="reviews.length > 0">
                <div class="cards">
                    <div class="card" *ngFor="let review of reviews">
                        <div class="review-bar">
                            <mat-icon *ngFor="let star of [1, 2, 3, 4, 5]">
                                <ng-container *ngIf="review.stars >= star">
                                    star
                                </ng-container>
                                <ng-container *ngIf="review.stars < star">
                                    star_border
                                </ng-container>
                            </mat-icon>
                        </div>
                        <h5>{{ review.title }}</h5>
                        <p>{{ review.body }}</p>
                    </div>
                </div>
            </div>
            <div class="benefits border">
                <h6>Benefits to partnership</h6>
                <div class="ticks">
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Personal Dashboard</span>
                    </div>
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Qualified Leads</span>
                    </div>
                    <div class="tick">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>Exclusive Partner Profile</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngSwitchCase="applicationStageEnum.SENT" class="sent">
            <mat-icon svgIcon="search-results"></mat-icon>
            <h1>Application Submitted!</h1>
            <p class="description">
                We’ve received your application, and we’ll review it as soon as
                possible. If you’re successful, we’ll be in touch with further
                instructions through the email you provided.
            </p>
            <app-button [config]="{
                    title: 'Back to Listique',
                    type: 'link',
                    url: '/'
                }"></app-button>
        </div>
    </ng-container>
</div>